import React from "react";
import Text from "./Text";
import { BUTTON_BASE_CLASSES, getButtonStateClasses } from "./buttonStyles";

interface VirtualKeyboardKeyProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  disabled?: boolean;
}

const VirtualKeyboardKey: React.FC<VirtualKeyboardKeyProps> = ({
  children,
  className = "",
  disabled = false,
  ...rest
}) => {
  return (
    <button
      type="button"
      className={`flex h-16 w-16 items-center justify-center ${BUTTON_BASE_CLASSES} ${getButtonStateClasses(false, disabled)} ${className}`}
      disabled={disabled}
      {...rest}
    >
      <Text as="span" variant="heading/xl" weight="bold">
        {children}
      </Text>
    </button>
  );
};

export default VirtualKeyboardKey;
